import React from "react"

import { Container } from "./styles"

const WarningIcon = () => {
	return (
		<Container>
			<div class="warning">
				<div class="warning-body"></div>
				<div class="warning-dot"></div>
			</div>
		</Container>
	)
}

export default WarningIcon